import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Grid, Text, Group, Modal, ActionIcon } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';

import { useAddProfilePage } from '../../api/addProfilePage';
import { useGetProfiles } from '../../api/getProfiles';
import { useRemoveProfilePage } from '../../api/removeProfilePage';
import { profileTypes } from '../../types';

import { PagesSelect } from '@/components';
import { Departments } from '@/types';

type Params = {
  profile: profileTypes.Profile;
  department: Departments;
};

type PageParams = {
  page: profileTypes.Profile['pages'][0];
  profile: profileTypes.Profile;
};

const Page = ({ page, profile }: PageParams) => {
  const removePage = useRemoveProfilePage();

  return (
    <Group>
      <ActionIcon
        loading={removePage.isLoading}
        variant="filled"
        onClick={() => removePage.mutate({ profileId: profile._id, pageId: page._id })}
      >
        <IconTrash />
      </ActionIcon>
      <Text size="sm">{page.name}</Text>
    </Group>
  );
};

export const PagesModal = NiceModal.create(({ profile, department }: Params) => {
  const modal = useModal();
  const addPage = useAddProfilePage();

  const getProfiles = useGetProfiles({
    department,
    config: {
      onSuccess: ({ profiles }) => {
        modal.show({ profile: profiles.find((p) => p._id === profile._id), department });
      },
    },
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title={`${profile.name} pages`}
    >
      <Grid columns={1} my="md">
        {profile.pages.map((page) => (
          <Grid.Col span={1} key={page._id}>
            <Page key={page._id} page={page} profile={profile} />
          </Grid.Col>
        ))}
      </Grid>

      <PagesSelect
        value=""
        onSelect={(pageId) => addPage.mutate({ profileId: profile._id, pageId })}
        isLoading={addPage.isLoading || getProfiles.isFetching}
        disabled={profile.pages.map((page) => page._id)}
      />
    </Modal>
  );
});
